"use client";

import { GooglePlayBadgeLink } from "@/components/GooglePlayBadgeLink";
import { CinematicModal } from "@/components/ui/CinematicModal";
import { cinematicModalSubtitleClass, cinematicModalTitleClass } from "@/lib/cinematicModalStyles";
import { usePostHog } from "posthog-js/react";
import { useState } from "react";

export function GooglePlayMobileAction() {
  const [isOpen, setIsOpen] = useState(false);
  const posthog = usePostHog();

  const openModal = () => {
    posthog?.capture("google_play_mobile_prompt_opened", {
      placement: "homepage_mobile_header",
      app_package: "com.chickytutor",
    });
    setIsOpen(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        aria-label="Get ChickyTutor for Android"
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-white/70 transition-colors hover:bg-white/[0.06] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-300/60 active:bg-white/[0.09]"
      >
        <img
          src="/images/google-play-icon.svg"
          alt=""
          width={22}
          height={22}
          aria-hidden="true"
          className="h-[22px] w-[22px]"
        />
      </button>

      <CinematicModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth="md"
        panelClassName="sm:max-w-sm"
        contentClassName="p-5"
        titleId="google-play-mobile-dialog-title"
        dismissOnBackdropClick
      >
        <div className="pr-8">
          <h2 id="google-play-mobile-dialog-title" className={cinematicModalTitleClass}>
            ChickyTutor on Android
          </h2>
          <p className={cinematicModalSubtitleClass}>
            Continue your speaking practice on your phone.
          </p>
        </div>

        <div className="mt-5 flex justify-center">
          <GooglePlayBadgeLink placement="homepage_mobile_modal" />
        </div>
      </CinematicModal>
    </>
  );
}
